Controller.$inject = [];

function Controller() {

}

export function HuiProgressLabel() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-progress-label text-truncate" ng-transclude></div>
            `;
        }
    }
}